require('../../vendor/jquery.hc-sticky');
require('../../components/stickySidebar');

require('./includes/form');
(function(global) {
    function SecurityPage() {
        this.$iframe = $('#iframe_form');
        this.pauseLoadIframe = 1000;
        this.optionSidebar = {
            sidebarWrap: $('.page-sidebar'),
            contentWrap: $('.page-content'),
            anchorWrap: $('.page-sidebar__list'),
            menuItem: $('.security-menu__item'),
            durationScroll: 1000
        };

        this.sidebar = new global.StickySidebar(this.optionSidebar);
        this.sidebar.init();

        if (this.$iframe.length > 0) {
            $(window).on('load', function() {
                setTimeout(
                    function() {
                        this.form = new window.SecurityForm();
                        this.form.init();
                    }.bind(this),
                    this.pauseLoadIframe
                );
            });
        }
    }

    new SecurityPage();
})(window.wrike);



// WEBPACK FOOTER //
// ./assets/js/projects/security/security.js